export default [
  { value: "exhibition", name: "exhibition" },
  { value: "inbound", name: "inbound" },
  { value: "other", name: "other" },
]



// WEBPACK FOOTER //
// ./src/config/data/project_categories.js